import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getBusinessDetailedView, sendOtp } from "../../../redux/slices/BusinessProfileSlice";
import ProfileSectionLayout from "../../../components/ProfileSectionLayout/ProfileSectionLayout";
import {
    maskEmail,
    maskPhone,
    capitalizeWords,
} from "../../../helpers/helpers";
import CustomModal from "../../../components/CustomModal/CustomModal";
import OtpContent from "../../../components/OtpContent/OtpContent";
import NewEmailPhoneContent from "../../../components/NewEmailPhoneContent/NewEmailPhoneContent";
import { GLOBAL_CONSTANTS, TITLE_TXT } from "../../../constants/constants";
import ProfileDetail from "../../../components/Details/ProfileDetail";

const PersonalDetails = () => {
    const dispatch = useDispatch();
    const { busDetailedViewData, loading } = useSelector((state) => state.profile1);
    const [showEmail, setShowEmail] = useState(false);
    const [showPhone, setShowPhone] = useState(false);
    const [oldDetailOtpModalOpen, setOldDetailOtpModalOpen] = useState(false);
    const [newDetailModalOpen, setNewDetailModalOpen] = useState(false);
    const [newDetailOtpModalOpen, setNewDetailOtpModalOpen] = useState(false);
    const [isMobileOtp, setIsMobileOtp] = useState(false);
    const [newDetail, setNewDetail] = useState(null);

    useEffect(() => {
        dispatch(getBusinessDetailedView());
    }, [dispatch]);

    const handleDetailEdit = (detail) => {
        setOldDetailOtpModalOpen(true);
        const payload = detail === "phone"
            ? { mobile: busDetailedViewData?.userDetails?.phoneNumber }
            : { email: busDetailedViewData?.userDetails?.email };
        setIsMobileOtp(detail === "phone");
        dispatch(sendOtp(payload));
    };

    return (
        <>
            <ProfileSectionLayout loading={loading} title={TITLE_TXT.PER_DETS}>
                        <div className="profile-detail-row">
                            <ProfileDetail
                                label={GLOBAL_CONSTANTS.NAME_AS_PER_PAN}
                                value={busDetailedViewData?.userDetails?.contactName}
                            />
                        </div>
                        <div className="profile-detail-row">
                            <ProfileDetail
                                label={GLOBAL_CONSTANTS.EMAIL}
                                value={showEmail
                                    ? busDetailedViewData?.userDetails?.email
                                    : maskEmail(busDetailedViewData?.userDetails?.email)}
                                isVerified={busDetailedViewData?.kycDetails?.kycEmail?.isVerified}
                                showValue={showEmail}
                                setShowValue={setShowEmail}
                                onEdit={() => handleDetailEdit("email")}
                                isMasked
                                isEditable
                            />
                        </div>

                        <div className="profile-detail-row">
                            <ProfileDetail
                                label={GLOBAL_CONSTANTS.PH_NUM}
                                value={`+91 ${showPhone
                                    ? busDetailedViewData?.userDetails?.phoneNumber
                                    : maskPhone(busDetailedViewData?.userDetails?.phoneNumber)}`}
                                isVerified={busDetailedViewData?.kycDetails?.kycMobile?.isVerified}
                                showValue={showPhone}
                                setShowValue={setShowPhone}
                                onEdit={() => handleDetailEdit("phone")}
                                isMasked
                                isEditable
                            />
                        </div>

                        <div className="profile-detail-row">
                            <ProfileDetail
                                label={GLOBAL_CONSTANTS.DESIG}
                                value={capitalizeWords(busDetailedViewData?.userDetails?.designation) || GLOBAL_CONSTANTS.NA}
                            />
                        </div>

                        <div className="profile-detail-row">
                            <ProfileDetail
                                label={GLOBAL_CONSTANTS.COMM_ADD}
                                value={
                                    [
                                        busDetailedViewData?.primaryAdd?.address1,
                                        busDetailedViewData?.primaryAdd?.address2,
                                        busDetailedViewData?.primaryAdd?.city,
                                        busDetailedViewData?.primaryAdd?.state,
                                        busDetailedViewData?.primaryAdd?.country,
                                        busDetailedViewData?.primaryAdd?.pinCode,
                                    ]
                                        .filter(Boolean)
                                        .join(", ") || GLOBAL_CONSTANTS.NA
                                }
                                isVerified={busDetailedViewData?.kycDetails?.kycGstinValue?.isVerified}
                            />
                        </div>
            </ProfileSectionLayout>

            {oldDetailOtpModalOpen && (
                        <CustomModal
                            open={oldDetailOtpModalOpen}
                            centered
                            maskClosable={false}
                            onCancel={() => {
                                setOldDetailOtpModalOpen(false);
                                setIsMobileOtp(false);
                            }}
                            content={
                                <OtpContent
                                    oldDetailOtpModalOpen={oldDetailOtpModalOpen}
                                    onClose={() => setOldDetailOtpModalOpen(false)}
                                    setNewDetailModalOpen={setNewDetailModalOpen}
                                    isMobileOtp={isMobileOtp}
                                    oldDetail={isMobileOtp ? busDetailedViewData?.userDetails?.phoneNumber : busDetailedViewData?.userDetails?.email}
                                />
                            }
                        />
            )}

            {newDetailModalOpen && (
                        <CustomModal
                            open={newDetailModalOpen}
                            centered
                            maskClosable={false}
                            onCancel={() => {
                                setNewDetailModalOpen(false);
                                setIsMobileOtp(false);
                            }}
                            content={
                                <NewEmailPhoneContent
                                    onClose={() => setNewDetailModalOpen(false)}
                                    setNewDetailOtpModalOpen={setNewDetailOtpModalOpen}
                                    setNewDetail={setNewDetail}
                                    isMobileOtp={isMobileOtp}
                                />
                            }
                        />
            )}

            {newDetailOtpModalOpen && (
                        <CustomModal
                            open={newDetailOtpModalOpen}
                            centered
                            maskClosable={false}
                            onCancel={() => {
                                setNewDetailOtpModalOpen(false);
                                setIsMobileOtp(false);
                            }}
                            content={
                                <OtpContent
                                    newDetail={newDetail}
                                    setNewDetail={setNewDetail}
                                    newDetailOtpModalOpen={newDetailOtpModalOpen}
                                    setNewDetailModalOpen={setNewDetailModalOpen}
                                    onClose={() => setNewDetailOtpModalOpen(false)}
                                    isMobileOtp={isMobileOtp}
                                />
                            }
                        />
            )}
        </>
    );
};

export default PersonalDetails;
